import React from 'react'
import styles from './profile.module.css'

const PostList =()=>{
    return(
        <div>
               <div className={styles.postgallery}>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
            <img src="http://joombig.com/demo-extensions1/images/gallery_slider/Swan_large.jpg"/>
        </div>

        </div>
    )
}

export default PostList;